export const UNCATEGORIZED = 'UNCATEGORIZED';
export const LIMIT_INCREASE = 'LIMIT_INCREASE';
export const REMOVE_BRANDING = 'REMOVE_BRANDING';